import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { IconButton, TextField } from '@mui/material';
import { useConfirm } from 'material-ui-confirm';

import { trpc } from '../../api/trpc';
import { Edit } from '@mui/icons-material';
import { Row } from '../../atoms/row';
import { useSelector } from '../../store/utils';

export const WifiApPassphraseEdit = () => {
  const managedNetwork = useSelector(
    (s) => s.variables.NETWORK_CAPABILITIES.managedNetwork
  );

  const confirm = useConfirm();

  const passphrase = useRef('');

  const utils = trpc.useContext();
  const setPassphraseMutation = trpc.setWifiPassphrase.useMutation({
    onSuccess: () => {
      utils.network.get.invalidate();
    },
  });

  const { data } = trpc.network.get.useQuery(undefined, {
    refetchInterval: 5000,
    enabled: managedNetwork,
  });

  const onPassphraseEditClick = () => {
    passphrase.current = data?.wifiApConfig?.passphrase ?? '';

    confirm({
      title: (
        <FormattedMessage
          id="wifi_ap_config.passphrase_change.confirm.title"
          defaultMessage="Změna hesla k WiFi"
        />
      ),
      content: (
        <>
          <TextField
            defaultValue={data?.wifiApConfig?.passphrase ?? ''}
            onChange={(e) => {
              passphrase.current = e.target.value;
            }}
            size="small"
            sx={{ my: 1 }}
            label={
              <FormattedMessage
                id="wifi_ap_config.passphrase_change.confirm.passphrase"
                defaultMessage="Heslo"
              />
            }
          />
        </>
      ),
    }).then(
      () => {
        setPassphraseMutation.mutate({ passphrase: passphrase.current });
      },
      () => {
        // noop
      }
    );
  };

  return (
    <>
      {data && (
        <Row gap={1} justifyContent="flex-end">
          <span>{data.wifiApConfig?.passphrase}</span>
          <IconButton size="small" onClick={onPassphraseEditClick}>
            <Edit />
          </IconButton>
        </Row>
      )}
    </>
  );
};
